/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FamilyPoolInvitationUpdateRequest
 */
export interface FamilyPoolInvitationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof FamilyPoolInvitationUpdateRequest
     */
    status: FamilyPoolInvitationUpdateRequestStatusEnum;
}


/**
 * @export
 */
export const FamilyPoolInvitationUpdateRequestStatusEnum = {
    Accepted: 'accepted',
    Declined: 'declined'
} as const;
export type FamilyPoolInvitationUpdateRequestStatusEnum = typeof FamilyPoolInvitationUpdateRequestStatusEnum[keyof typeof FamilyPoolInvitationUpdateRequestStatusEnum];


/**
 * Check if a given object implements the FamilyPoolInvitationUpdateRequest interface.
 */
export function instanceOfFamilyPoolInvitationUpdateRequest(value: object): value is FamilyPoolInvitationUpdateRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function FamilyPoolInvitationUpdateRequestFromJSON(json: any): FamilyPoolInvitationUpdateRequest {
    return FamilyPoolInvitationUpdateRequestFromJSONTyped(json, false);
}

export function FamilyPoolInvitationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolInvitationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function FamilyPoolInvitationUpdateRequestToJSON(json: any): FamilyPoolInvitationUpdateRequest {
    return FamilyPoolInvitationUpdateRequestToJSONTyped(json, false);
}

export function FamilyPoolInvitationUpdateRequestToJSONTyped(value?: FamilyPoolInvitationUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

